module.exports = __webpack_public_path__ + "media/images/dmc/member-02-ce212de14003cb3d693da793325deac7.jpg";